module.exports = __webpack_public_path__ + "img/map-2.e8c4fd44.png";